import script from "./OrganizationList.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationList.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationList.vue?vue&type=style&index=0&id=85aa1554&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85aa1554"]])

export default __exports__